module.exports = __webpack_public_path__ + "static/media/deleted-entries-icon.dc473d3f.svg";